import {
  GETNOTIFICATION,
  GETNOTIFICATION_SUCCESS,
  GETNOTIFICATION_ERROR,
    getNotificationsSuccess,
    getNotificationsError,
    setNotifications,

    
  } from "../../actions/alert";
import { apiRequest } from "../../actions/api";
import { notification_types } from "../../../js/constants";
import { setNotification } from "../../actions/notification";

  export const getNotificationflow = ({ dispatch }) => (next) => (action) => {
  next(action);

  if (action.type === GETNOTIFICATION) {
    const page = action.payload?.page || 1;
    
    dispatch(
      apiRequest(
        "GET",
        `/apiCall.php?apiCall=GetNotification&page=${page}`,
        null,
        null,
        (data) => getNotificationsSuccess(data, { page }),
        getNotificationsError,
        false,
        "[Notification]"
      )
    );
  }
};

export const processgetNotifications = ({ dispatch }) => (next) => (action) => {
  next(action);

  if (action.type === GETNOTIFICATION_SUCCESS) {
    const page = action.meta?.page || 1;
    const notificationList = action.payload.data || [];
    const hasMore = action.payload.hasMore ?? false;

    dispatch(setNotifications(notificationList, page, hasMore));
  }

  if (action.type === GETNOTIFICATION_ERROR) {
    // Handle error state if needed
  }
};

export const NotificationMdl = [
  getNotificationflow,
  processgetNotifications
];